import React from 'react';
import classnames from 'classnames';
import { useDebounceFn } from 'ahooks';
import type { IGeneralLegendContentProps } from '@/pages/intelligence/components/GeneralLegend/types';
import './index.scss';

const GeneralLegendContent: React.FC<IGeneralLegendContentProps> = (props) => {
  const { type = 'circle', showDot = true, showIcon = false, name, color, icon, formatter, value, onChange, onMouseEnter, onMouseOver, onMouseMove, onMouseLeave } = props;

  const { run: handleClickRun } = useDebounceFn(
    (e: React.SyntheticEvent<HTMLDivElement>) => {
      e?.stopPropagation();
      e?.preventDefault();
      const valueTmp = !value;
      onChange(valueTmp, e);
    },
    { wait: 300, trailing: true, leading: true },
  );

  return (
    <div
      className={classnames({
        'dbi-general-legend-content': true,
        active: value,
        inactive: !value,
      })}
      onClick={handleClickRun}
      onMouseEnter={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onMouseEnter?.({ name }, e);
      }}
      onMouseOver={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onMouseOver?.({ name }, e);
      }}
      onMouseMove={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onMouseMove?.({ name }, e);
      }}
      onMouseLeave={(e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onMouseLeave?.({ name }, e);
      }}
    >
      {showDot && (
        <span
          style={{ backgroundColor: color }}
          className={classnames({
            'dbi-general-legend-content_dot': true,
            circle: type === 'circle',
            square: type === 'square',
          })}
        ></span>
      )}
      {showIcon && <img src={icon} className="dbi-general-legend-content_icon" alt="" />}
      <span className="dbi-general-legend-content_name">{formatter?.(name) ?? name}</span>
    </div>
  );
};

export default GeneralLegendContent;
